var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-dropzone',{ref:"iconDropzone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.triggerAppIconListReload}})
}
var staticRenderFns = []

export { render, staticRenderFns }